import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_order_analytics: { message: "idle" },
};

export const retrieve_tenant_order_analytics_Slice = createSlice({
 name: "retrieve_tenant_order_analytics",
 initialState,
 reducers: {
  success_retrieve_tenant_order_analytics: (state, action) => {
   state.retrieve_tenant_order_analytics = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_order_analytics: (state, action) => {
   state.retrieve_tenant_order_analytics = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_order_analytics: (state) => {
   state.retrieve_tenant_order_analytics = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_order_analytics: (state) => {
   state.retrieve_tenant_order_analytics = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_order_analytics, fail_retrieve_tenant_order_analytics, reset_retrieve_tenant_order_analytics, loading_retrieve_tenant_order_analytics } = retrieve_tenant_order_analytics_Slice.actions;

export default retrieve_tenant_order_analytics_Slice.reducer;